import React, { Suspense } from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import Loadable from "react-loadable"
import { isAuthenticated } from "@services/auth"
import "../../node_modules/font-awesome/scss/font-awesome.scss"
import { ReportProvider } from "@src/context/ReportContext"
import LoadingModal from "@components/LoadingModal"
import "semantic-ui-css/semantic.min.css"
import "bootstrap/dist/css/bootstrap.min.css"
import Loader from "./layout/Loader"
import Aux from "../hoc/_Aux"
import ScrollToTop from "./layout/ScrollToTop"
import routes from "@src/routes/route"

const AdminLayout = Loadable({
  loader: () => import("./layout/AdminLayout"),
  loading: Loader,
})

const App = (props) => {
  const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
        )
      }
    />
  )

  const menu = routes.map((route, index) => {
    return route.component ? (
      <Route
        key={index}
        path={route.path}
        exact={route.exact}
        name={route.name}
        render={(props) =>
          isAuthenticated() && props.location.pathname === "/login" ? (
            <Redirect to={{ pathname: "/dashboard", state: { from: props.location } }} />
          ) : (
            <route.component {...props} />
          )
        }
      />
    ) : null
  })

  return (
    <Aux>
      <ScrollToTop>
        <Suspense fallback={<Loader />}>
          <ReportProvider>
            <LoadingModal />
            <Switch>
              {menu}
              <PrivateRoute path="/" component={AdminLayout} />
            </Switch>
          </ReportProvider>
        </Suspense>
      </ScrollToTop>
    </Aux>
  )
}

export default App
